<template>
  <b-list-group>
    <b-list-group-item
      v-for="i in parentInstances"
      :key="i._id"
      class="bg-dark "
      variant="dark"
    >
      <router-link
        :to="'/projects/' + hasProject(i)._id"
        :is="user != me._id ? 'span' : 'router-link'"
      >
        <div class="d-grid grid-project ">
          <h4 class="font-weight-bold text-white font-size-lg mb-4">
            {{ hasProject(i).title }}
          </h4>
        </div>
        <b-list-group v-if="i.instances.length > 0">
          <b-list-group-item
            v-for="child in getInstances(i.instances)"
            :key="child._id"
          >
            <div class="d-grid grid-child text-dark-75">
              <span class="font-weigth-bolder">{{
                hasProject(child).title
              }}</span>
              <span class="versions">{{ child.proof.length }} versions</span>
              <span class="stars"
                >{{ child.stars ? child.stars : "0" }}
                <b-icon-star></b-icon-star
              ></span>
              <span
                class="status label label-inline label-sm"
                :class="child.dateFinished ? 'label-success' : 'label-warning'"
                >{{ child.dateFinished ? "CLOSED" : "LIVE" }}
              </span>
            </div>
          </b-list-group-item>
        </b-list-group>
        <b-list-group v-else>
          <b-list-group-item>
            <div class="d-grid grid-child text-dark-75">
              <span class="font-weigth-bolder">No Sections</span>
              <span class="versions">{{ i.proof.length }} versions</span>
              <span class="stars"
                >{{ i.stars ? i.stars : "0" }} <b-icon-star></b-icon-star
              ></span>
              <span
                class="status label label-inline label-sm"
                :class="i.dateFinished ? 'label-success' : 'label-warning'"
                >{{ i.dateFinished ? "CLOSED" : "LIVE" }}
              </span>
            </div>
          </b-list-group-item>
        </b-list-group>
      </router-link>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
//import DashboardProfiles from "@/view/layout/dashboard/DashboardProfiles";
export default {
  name: "ActiveProjects",
  components: {},
  props: {
    user: String
  },
  computed: {
    me() {
      return this.$store.getters.getMyUser;
    },
    instances() {
      if (this.user == this.me._id) {
        return this.$store.getters.getMyInstances;
      } else {
        console.log(this.$store.getters.getInstances);
        return this.$store.getters.getMyTeam.users.find(u => u._id == this.user)
          .instances;
      }
    },

    projects() {
      return this.$store.getters.getProjects;
    },
    parentInstances() {
      return this.instances.filter(
        i => this.projects.find(p => p._id == i.project).hasParent == false
      );
    }
  },
  methods: {
    hasProject(i) {
      return this.projects.find(p => i.project == p._id);
    },
    getInstances(instancesId) {
      return this.instances.filter(p => instancesId.includes(p._id));
    }
  }
};
</script>

<style lang="scss" scoped>
.d-grid {
  display: grid;
  &.grid-child {
    align-items: center;
    grid-template-columns: repeat(1, 3fr 2fr 50px 1fr);
  }
  &.grid-project {
    grid-template-columns: repeat(1, 3fr 1fr);
  }
}
</style>
